module.exports = require("@wildboar/x500/src/lib/modules/DirectoryIDMProtocols/dap-ip.oa");